import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";

import { getWordinariusFirebaseApp } from "./firebaseApp";

const PROJECT_ID = "wordinariusecho";
const REGION = "europe-west1";

interface CallableEnvelope<T> {
  result?: T;
  data?: T;
  error?: { message?: string; status?: string };
}

export async function callPublicWordinariusFunction<T>(name: string, data: unknown): Promise<T> {
  const app = getWordinariusFirebaseApp();
  if (app) {
    const callable = httpsCallable<unknown, T>(getFunctions(app, REGION), name);
    const response = await callable(data);
    return response.data;
  }

  const response = await fetch(`https://${REGION}-${PROJECT_ID}.cloudfunctions.net/${name}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ data }),
  });
  const envelope = await response.json() as CallableEnvelope<T>;
  if (!response.ok || envelope.error) {
    throw new Error(envelope.error?.message || `callable_failed:${name}`);
  }
  const result = envelope.result ?? envelope.data;
  if (!result) {
    throw new Error(`callable_empty:${name}`);
  }
  return result;
}

export async function callAuthenticatedWordinariusFunction<T>(name: string, data: unknown): Promise<T> {
  const app = getWordinariusFirebaseApp();
  if (!app) {
    throw new Error("firebase_unavailable");
  }
  const auth = getAuth(app);
  if (!auth.currentUser) {
    throw new Error("auth_required");
  }
  await auth.currentUser.getIdToken();
  const callable = httpsCallable<unknown, T>(getFunctions(app, REGION), name);
  const response = await callable(data);
  return response.data;
}
